exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert-flash {\n    position: fixed;\n    right: 25px;\n    top: 25px;\n    width: 350px;\n    z-index: 9999;\n}\n.alert-flash:hover {\n    display: block !important;\n}\n@media (max-width: 767.98px) {\n.alert-flash {\n        width: 300px;\n        right: 10px;\n}\n}\n", ""]);

// exports
